import { OutsidePage } from '../components/outside_page';
import { OutsidePageContent } from '../components/outside_page_content';
import { UnderlineInput } from '../components/underline_input';
const LoginPage = React.createClass({
    displayName: 'LoginPage',
    getInitialState() {
        return {
        	username: '',
        	password: '',
        	status: true,
        	message: '',
            isLoading: false,
        	helperLinks: [
        		{
        			text: Skywatch.langs.register.toUpperCase(),
        			url: 'register_account'
        		},
        		{
        			text: Skywatch.langs.forget_password,
        			url: 'forget_password'
        		},
        		{
        			text: Skywatch.langs.resend_verification,
        			url: 'resend_verification'
        		}
        	],
            supportedLangs: Object.keys(Skywatch.supported_langs).map((key) => {
                return {
                    tag: key,
                    name: Skywatch.supported_langs[key]
                };
            })
        };
    },
    tryDemo() {
        // Try out demo account
        this.setState({
            username: Skywatch.demo_account,
            password: Skywatch.demo_password
        });
        this.signIn(true);
    },
    signIn(isTry) {
        isTry = isTry === true;
        // set loading
        this.setState({ 
            isLoading: true,
            message: '',
            status: true
        });

        if(!isTry && (this.state.username.trim() == '' || this.state.password.trim() == '')) {
            this.setState({ 
                isLoading: false,
                message: Skywatch.langs.please_username_and_password,
                status: false
            });
            return;
        }

        var username = this.state.username;
        var password = this.state.password;
        if(isTry) {
            username = Skywatch.demo_account;
            password = Skywatch.demo_password;
        }

        // set params
        var params = {
            username : username,
            password : $.md5(password),
            scope: 'login',
        };
        // authorization
        $.post(Skywatch.api_path + 'validation', params)
            .done((api_key) => {
                api_key = api_key.replace(/<script.*script>/, '');
                $.cookie('api_key', api_key, { path: '/' });

                window.location = 'main_page';
                window.localStorage.clear();
            }).fail(() => {
                this.setState({ 
                    isLoading: false,
                    status: false,
                    message: Skywatch.langs.account_or_password_error 
                });
            });
    },
    handleKeyPress(event) {
        if(event.charCode == 13) {
            event.preventDefault();
            event.stopPropagation();
            this.signIn();
        }

    },
    getContent() {
    	return (
    		<div className="login-content">
    			<div className="main-content">
	    			<img className="logo" src={Skywatch.logo}/>
	    			<div className="username-input">
	    				<UnderlineInput 
	    					value={this.state.username} 
	    					placeHolder={Skywatch.langs.username_placeholder} 
	    					onChange={(event) => this.setState({username: event.target.value})}
	    				/>
	    			</div>
	    			<div className="password-input">
	    				<UnderlineInput 
                            inputType="password" 
	    					value={this.state.password}
	    					placeHolder={Skywatch.langs.password_placeholder} 
	    					onChange={(event) => {
                                this.setState({password: event.target.value})}}
                            onKeyPress={this.handleKeyPress}
	    				/>
	    			</div>
                    <div className={`outside-page-message ${this.state.status ? '' : 'outside-page-error-message'}`}>
	    			    {this.state.message}
                    </div>
                    <div className="login-button-container outside-page-buttons">
                        {Skywatch.show_try_it ? 
    	    				<button className="ghost-orange-button outside-page-btn" onClick={this.tryDemo}> {Skywatch.langs.try_our_demo}</button>
                            :
                            null
                        }
	    				<button className={`blue-btn outside-page-btn ${this.state.isLoading ? 'loading' : ''}`}  onClick={this.signIn}>{Skywatch.langs.login}</button>
	    			</div>
	    		</div>
	    		<div className="helper-links-container">
                    <div className="helper-links">
	    			    {this.state.helperLinks.map((link) => <a className="helper-link" href={link.url}> {link.text} </a>)}
	    		    </div>
                </div>
    		</div>
    	);
    },
    render() {
    	return (
    		<OutsidePage supportedLangs={this.state.supportedLangs} backgroundImage={Skywatch.backgroundImage}>
    			{this.getContent()}
    		</OutsidePage>
    	);
    }
});

React.render(
    <LoginPage />,
    document.getElementById('content')
);


// WEBPACK FOOTER //
// ../modules/js/v3/login/index.js